<template>
  <div class="wrapper">
    <div class="loginCard">
      <el-card shadow="hover">
        <div class="mooctestlogo"></div>
        <div class="stuEnd">学生端</div>
        <div style="text-align: center">
          <h2
            style="
              font-family:
                Helvetica Neue,
                Helvetica,
                Arial,
                sans-serif;
              margin-right: -2em;
              margin-top: 7px;
              margin-bottom: 10px;
            "
          >
            MOOCTEST
            <el-button circle type="text" @click="changeLang">中/Eng</el-button>
          </h2>
        </div>
        <el-form
          @submit.native.prevent
          :model="loginForm"
          ref="loginForm"
          label-position="left"
          label-width="75px"
        >
          <el-form-item
            :label="$t('loginPage.email')"
            prop="email"
            :rules="[{ required: true, message: $t('loginPage.emailNotNull') }]"
          >
            <el-input
              :placeholder="$t('loginPage.inputEmail')"
              v-model="loginForm.email"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('loginPage.password')"
            prop="password"
            :rules="[
              {
                required: true,
                message: $t('loginPage.passwordNotNull'),
                trigger: ['blur'],
              },
            ]"
          >
            <el-input
              type="password"
              :placeholder="$t('loginPage.inputPsd')"
              v-model="loginForm.password"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-button
            style="float: right; padding-top: 0; margin-bottom: 10px"
            type="text"
            @click="startForgetPassword"
          >
            {{ $t("loginPage.forgetPassword") }}
          </el-button>
        </el-form>

        <div class="bottom">
          <el-link style="color: #409eff" href="http://manage.mooctest.net">
            {{ $t("loginPage.manageEntrance") }}
          </el-link>
          <div class="btnContainer">
            <el-button type="primary" @click="submitForm('loginForm')"
              >{{ $t("loginPage.login") }}
            </el-button>
            <router-link to="register">
              <el-button type="primary" plain
                >{{ $t("loginPage.register") }}
              </el-button>
            </router-link>
          </div>
        </div>
      </el-card>
    </div>
    <div
      style="
        position: absolute;
        bottom: 10px;
        right: 10px;
        color: white;
        font-size: 20px;
        font-weight: 600;
      "
    >
      <p>版权所有： 南京慕测信息科技有限公司</p>
      <p>
        <a
          style="text-decoration: none; color: inherit"
          href="https://beian.miit.gov.cn/"
          >苏ICP备14002894号-3</a
        >
      </p>
    </div>
    <el-dialog
      :title="$t('loginPage.ForgetPassword')"
      :visible.sync="forgetPasswordDialog"
      :before-close="cancelForgetPassword"
    >
      <div v-if="sendEmail">
        <div
          class="el-icon-success"
          style="
            margin: 0 auto;
            display: block;
            width: 120px;
            color: #67c23a;
            font-size: 120px;
          "
        ></div>
        <p style="text-align: center">
          {{ $t("loginPage.sendEmailInfo", { e: forgetPasswordForm.email }) }}
        </p>
      </div>
      <div v-if="!sendEmail" v-loading="forgetPasswordLoading">
        <div style="font-size: 16px; margin-bottom: 10px">
          {{ $t("loginPage.emailPlaceholder") }}
        </div>
        <el-form
          @submit.native.prevent
          :model="forgetPasswordForm"
          ref="forgetPasswordForm"
          label-position="left"
          label-width="100px"
        >
          <el-form-item
            :label="$t('loginPage.email')"
            prop="email"
            :rules="[
              {
                required: true,
                message: $t('loginPage.emailNotNull'),
                trigger: ['blur'],
              },
              {
                type: 'email',
                message: $t('common.emailFormat'),
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-input
              :placeholder="$t('loginPage.email')"
              v-model="forgetPasswordForm.email"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('loginPage.captcha')"
            prop="captcha"
            :rules="[{ required: true, message: $t('common.notNull') }]"
          >
            <el-input
              :placeholder="$t('loginPage.captcha')"
              v-model="forgetPasswordForm.captcha"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <img
              :src="captchaImage"
              :alt="$t('loginPage.captcha')"
              width="100px"
            />
            <el-button
              type="text"
              @click="refreshCaptcha"
              style="vertical-align: bottom; padding: 5px"
              >{{ $t("loginPage.changeOne") }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" v-if="!sendEmail">
        <el-button
          :disabled="forgetPasswordLoading"
          type="primary"
          @click="confirmForgetPassword"
          >{{ $t("button.confirm") }}</el-button
        >
        <el-button
          :disabled="forgetPasswordLoading"
          @click="cancelForgetPassword"
          >{{ $t("button.cancel") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { login, userInfoGet } from "../api/user";
import { findPassword, getCaptcha } from "../api/common";

export default {
  data() {
    return {
      loginForm: {
        password: "",
        email: "",
      },
      captchaImage: "",
      forgetPasswordDialog: false,
      forgetPasswordForm: {
        captcha: "",
        email: "",
      },
      sendEmail: false,
      forgetPasswordLoading: false,
    };
  },
  methods: {
    submitForm() {
      let that = this;
      this.$refs["loginForm"].validate().then((valid) => {
        if (valid) {
          //表单验证成功后，开始登录
          login(this.loginForm.email, this.loginForm.password)
            .then((res) => {
              this.$notify({
                type: "success",
                title: that.$t("common.success"),
                duration: 3000,
              });
              localStorage.setItem("loginStatus", true);
              localStorage.setItem("uid", res.id);
              localStorage.setItem("email", res.email);
              localStorage.setItem("user", JSON.stringify(res));
              this.$router.push("/home");
            })
            .catch((error) => {
              if (error.response.status === 400) {
                this.$notify({
                  type: "error",
                  title: that.$t("common.fail"),
                  duration: 3000,
                  message: that.$t("loginPage.loginError"),
                });
              }
            });
        } else {
          //表单验证部分，判断输入是否为空，此处可以优化，抽离方法，并抽象验证方式
          this.$notify({
            type: "warning",
            title: that.$t("common.error"),
            duration: 3000,
            message: that.$t("common.formatInfo"),
          });
        } //if
      }); //valid
    },
    changeLang() {
      if (this.$i18n.locale === "cn") {
        this.$i18n.locale = "en";
        localStorage.setItem("lang", "en");
      } else {
        this.$i18n.locale = "cn";
        localStorage.setItem("lang", "cn");
      }
    },
    startForgetPassword() {
      this.refreshCaptcha();
      this.forgetPasswordDialog = true;
    },
    refreshCaptcha() {
      getCaptcha()
        .then((res) => {
          const blob = new Blob([res], { type: "image/jpeg" }); // 替换为实际的图像类型
          this.captchaImage = URL.createObjectURL(blob);
        })
        .catch((error) => {
          console.error("Error fetching captcha image:", error);
        });
    },
    cancelForgetPassword() {
      this.forgetPasswordForm = {
        captcha: "",
        email: "",
      };
      this.forgetPasswordDialog = false;
      this.sendEmail = false;
    },
    confirmForgetPassword() {
      this.$refs["forgetPasswordForm"]
        .validate()
        .then((valid) => {
          if (valid) {
            //表单验证成功后，开始登录
            this.forgetPasswordLoading = true;
            findPassword(
              this.forgetPasswordForm.email,
              this.forgetPasswordForm.captcha,
            )
              .then((res) => {
                this.forgetPasswordLoading = false;
                this.sendEmail = true;
              })
              .catch((error) => {
                this.forgetPasswordLoading = false;
                this.$notify({
                  type: "warning",
                  title: "输入错误",
                  duration: 3000,
                  message: error.response.data.message,
                });
              });
          }
        })
        .catch((err) => {
          this.$notify({
            type: "warning",
            title: "输入错误",
            duration: 3000,
            message: "请按照提示规范填写",
          });
        }); //valid
    },
  },
};
</script>

<style scoped>
.wrapper {
  /* position: absolute; */
  /* background-color: red; */
  background: url("../assets/img/loginBg.jpeg");
  /* height: 100vh;
  width: 100vh; */

  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #fff;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  min-height: 700px;
  /*overflow: auto;*/
  overflow: visible;
  position: relative;
}

.mooctestlogo {
  background-image: url("../assets/img/mooctestlogo.png");
  background-size: cover;
  width: 91px;
  height: 100px;
  margin: 0 auto;
}

.loginCard {
  height: 400px;
  width: 500px;
  /* background-color: aqua; */
  margin: 100px auto;
}

.stuEnd {
  text-align: center;
  font-size: 22px;
  color: #0066ba;
  margin-top: 20px;
  font-weight: bold;
  letter-spacing: 1px;
}

.bottom {
  clear: both;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
}

.btnContainer {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 0 auto;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>
